export { default as Icon } from "./icon";

import DsLogo from "./ds-logo-icon";
import DSCoolingIcon from "./ds-cooling.icon";
import DsSucceededIcon from "./ds-succeeded-icon";
import DsArrowIcon from "./ds-arrow-icon";
import DsCompanyIcon from "./ds-company-icon";
import DsMenuIcon from "./ds-menu-icon";
import DsUserIcon from "./ds-user-icon";
import DsLockIcon from "./ds-lock-icon";
import DsAdministrationIcon from "./ds-administration-icon";
import DsCubeIcon from "./ds-cube-icon";
import DsSettingsIcon from "./ds-settings-icon";
import DsPenIcon from "./ds-pen-icon";
import DsServerIcon from "./ds-server-icon";
import DsServerStatusOnIcon from "./ds-server-status-on-icon";
import DsServerStatusOffIcon from "./ds-server-status-off-icon";
import DsConfirmedIcon from "./ds-confirmed-icon";
import DsUnconfirmedIcon from "./ds-unconfirmed-icon";
import DsAlertIcon from "./ds-alert-icon";
import DsSquareIcon from "./ds-square-icon";
import DsEyeVisibleIcon from "./ds-eye-visible-icon";
import DsEyeNotVisibleIcon from "./ds-eye-not-visible-icon";
import DsShieldIcon from "./ds-shield-icon.vue";
import DsMessageIcon from "./ds-message-icon.vue";
import DsTicketNewIcon from "./ds-ticket-new-icon";
import DsTicketOpenIcon from "./ds-ticket-open-icon";
import DsTicketWaitingIcon from "./ds-ticket-waiting-icon";
import DsTicketMergedIcon from "./ds-ticket-merged-icon";
import DsTicketClosedIcon from "./ds-ticket-closed-icon";
import DsShieldInfoIcon from "./ds-shield-info-icon";
import DsShieldBlockingIcon from "./ds-shield-blocking-icon";
import DsCopyIcon from "./ds-copy-icon.vue";
import DsSourcePathIcon from "./ds-source-path-icon";
import DsPathIcon from "./ds-path-icon";
import DsInfoIcon from "./ds-info-icon";
import DsTriangleWarningIcon from "./ds-triangle-warning-icon";
import DsTriangleBlockIcon from "./ds-triangle-block-icon";
import DsTriangleAllowIcon from "./ds-triangle-allow-icon";
import DsFilterSwitchIcon from "./ds-filter-switch-icon";
import DsRemoveIcon from "./ds-remove-icon";
import DsSearchIcon from "./ds-search-icon";
import DsNoteIcon from "./ds-note-icon";
import DsPartialLogoIcon from "./ds-partial-logo-icon";
import DsDownloadIcon from "./ds-download-icon";
import DsDotsIcon from "./ds-dots-icon";
import DsFlyIcon from "./ds-fly-icon";

export default {
  DsLogo,
  DSCoolingIcon,
  DsSucceededIcon,
  DsArrowIcon,
  DsCompanyIcon,
  DsMenuIcon,
  DsUserIcon,
  DsLockIcon,
  DsAdministrationIcon,
  DsCubeIcon,
  DsSettingsIcon,
  DsPenIcon,
  DsServerIcon,
  DsServerStatusOnIcon,
  DsServerStatusOffIcon,
  DsConfirmedIcon,
  DsUnconfirmedIcon,
  DsAlertIcon,
  DsSquareIcon,
  DsEyeVisibleIcon,
  DsEyeNotVisibleIcon,
  DsShieldIcon,
  DsMessageIcon,
  DsTicketNewIcon,
  DsTicketOpenIcon,
  DsTicketWaitingIcon,
  DsTicketMergedIcon,
  DsTicketClosedIcon,
  DsShieldInfoIcon,
  DsShieldBlockingIcon,
  DsCopyIcon,
  DsSourcePathIcon,
  DsPathIcon,
  DsInfoIcon,
  DsTriangleWarningIcon,
  DsTriangleBlockIcon,
  DsTriangleAllowIcon,
  DsFilterSwitchIcon,
  DsRemoveIcon,
  DsSearchIcon,
  DsNoteIcon,
  DsPartialLogoIcon,
  DsDownloadIcon,
  DsDotsIcon,
  DsFlyIcon
};



//////////////////
// WEBPACK FOOTER
// ../panel-theme/src/js/icons/index.js
// module id = null
// module chunks = 